<template>
<div class="Mme">
    <me :kmctype="kmctype"></me>
    <mTab></mTab>
</div>
</template>

<script>
import MTab from 'views/mapply/components/mTab.vue'
import Me from 'views/mobile/my/me/components/me.vue'
export default {
    name: 'Mme',
    metaInfo: {
      title: '个人中心'
    },
    data() {
        return {
          kmctype: 13
        }
    },
    mounted() {},
    activated() {

    },
    methods: {
    },
    filters: {},
    watch: {
    },
    computed: {
    },
    components: {
        MTab, Me
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
#app {
}
.Mme {
}
</style>